import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { qsaiImages } from '../constants/index';
import styles from './muiStyles';
import colors from '../theme/colors';

const Logo = () => {
  return (
    <Box sx={styles.navigation.logo.container}>
      <Box sx={styles.navigation.logo}>
        <img
          src={`${qsaiImages}/ai-round-logo.svg`}
          alt="QSAI"
          style={styles.navigation.logo.roundLogo}
        />
        <Typography sx={styles.navigation.logo.text}>
          <span style={{ color: colors.secondary.main }}>QS</span>
          <span style={{ color: colors.primary.main }}>AI</span>
        </Typography>
      </Box>

      <Typography sx={styles.navigation.logo.poweredBy}>
        POWERED BY C-LINK
      </Typography>
    </Box>
  );
};

export default Logo;
